import { render, staticRenderFns } from "./GroupedOrder.vue?vue&type=template&id=22089704&"
import script from "./GroupedOrder.vue?vue&type=script&lang=js&"
export * from "./GroupedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports